var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
let ListPortNodeInput = class ListPortNodeInput extends LitElement {
    handleInputChange(event) {
        const input = event.detail.input;
        const key = this.key;
        if (key == 'output_ports') {
            this.dispatchEvent(new CustomEvent('node-ports-change', {
                detail: { ports: input.value },
                bubbles: true,
                composed: true
            }));
        }
    }
    render() {
        return html `<list-text-node-input
            .key=${this.key}
            .input=${this.input}
            @node-input-change=${this.handleInputChange}
        ></list-text-node-input>`;
    }
};
ListPortNodeInput.styles = css ``;
__decorate([
    property({ type: String })
], ListPortNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], ListPortNodeInput.prototype, "input", void 0);
ListPortNodeInput = __decorate([
    customElement("list-port-node-input")
], ListPortNodeInput);
export { ListPortNodeInput };
//# sourceMappingURL=ListPortNodeInput.js.map